import React from 'react';
import { LineChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const data = [
  { date: '2025-07-21', mentions: 28, price: 3.2 },
  { date: '2025-07-22', mentions: 2, price: 9.1 },
  { date: '2025-07-23', mentions: 1, price: 8.5 },
  { date: '2025-07-24', mentions: 2, price: 7.2 },
  { date: '2025-07-25', mentions: 1, price: 4.1 },
  { date: '2025-07-26', mentions: 3, price: 4.3 },
  { date: '2025-07-27', mentions: 2, price: 4.0 },
  { date: '2025-07-28', mentions: 1, price: 4.2 },
  { date: '2025-07-29', mentions: 2, price: 4.1 },
];

const OpenChart: React.FC = () => {
  return (
    <div className="bg-[#333] border border-[#444] rounded-lg p-4 sm:p-6">
      <div className="text-center mb-6">
        <h4 className="text-xl font-semibold text-white mb-2">
          Mentions of $OPEN vs Price (July 2025)
        </h4>
        <p className="text-[#bbb] text-sm">
          SentiHype Data
        </p>
      </div>
      
      <ResponsiveContainer width="100%" height={window.innerWidth < 768 ? 250 : 300}>
        <LineChart data={data} margin={{ top: 20, right: window.innerWidth < 768 ? 10 : 30, left: window.innerWidth < 768 ? 10 : 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#444" />
          <XAxis 
            dataKey="date" 
            stroke="#bbb"
            fontSize={window.innerWidth < 768 ? 10 : 12}
            tickFormatter={(value) => new Date(value).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit' })}
            angle={window.innerWidth < 768 ? -45 : 0}
            textAnchor={window.innerWidth < 768 ? 'end' : 'middle'}
            height={window.innerWidth < 768 ? 60 : 30}
          />
          <YAxis 
            yAxisId="left"
            stroke="#4ff6e6"
            fontSize={window.innerWidth < 768 ? 10 : 12}
            label={window.innerWidth < 768 ? undefined : { value: 'Mentions', angle: -90, position: 'insideLeft', fill: '#4ff6e6' }}
          />
          <YAxis 
            yAxisId="right"
            orientation="right"
            stroke="#ff6b6b"
            fontSize={window.innerWidth < 768 ? 10 : 12}
            label={window.innerWidth < 768 ? undefined : { value: 'Stock Price (approx)', angle: 90, position: 'insideRight', fill: '#ff6b6b' }}
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: '#1a1a1a', 
              border: '1px solid #333',
              borderRadius: '8px',
              color: '#fff'
            }}
            labelFormatter={(value) => new Date(value).toLocaleDateString('en-US', { 
              month: 'long', 
              day: 'numeric', 
              year: 'numeric' 
            })}
          />
          <Legend 
            wrapperStyle={{ 
              fontSize: window.innerWidth < 768 ? 10 : 12,
              paddingTop: window.innerWidth < 768 ? 10 : 0
            }}
          />
          <Bar 
            yAxisId="left"
            dataKey="mentions" 
            fill="#4ff6e6" 
            opacity={0.8}
            name="Mentions"
          />
          <Line 
            yAxisId="right"
            type="monotone" 
            dataKey="price" 
            stroke="#ff6b6b" 
            strokeWidth={3}
            dot={{ fill: '#ff6b6b', strokeWidth: 2, r: 4 }}
            name="Stock Price"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OpenChart; 